import React from 'react';
import image from '../images/image5.png';
import { TourGuideImage } from '../TourGuideImage';

export const Segment10 = () => (
    <TourGuideImage src={image} footnote={"Hand study with glass ball by Ernst Wenke, 1930"} />
);